import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaGithub,
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
  FaCalendarAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaHeart,
  FaPhoneAlt,
  FaChevronRight
} from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const socialLinks = [
    { icon: <FaInstagram />, url: 'https://www.instagram.com/the.loud_nerd/', label: 'Instagram', color: '#e4405f' },
    { icon: <FaFacebook />, url: 'https://www.facebook.com/ShyeeCodes', label: 'Facebook', color: '#1877f2' },
    { icon: <FaWhatsapp />, url: 'https://wa.me/254762272152', label: 'WhatsApp', color: '#25d366' },
    { icon: <FaGithub />, url: 'https://github.com/shyee-codes', label: 'GitHub', color: '#333333' },
  ];

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Ready Systems', path: '/ready-systems' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  const servicesLinks = [
    { name: 'Web Development', path: '/services' },
    { name: 'SEO Strategy', path: '/services' },
    { name: 'Social Media', path: '/services' },
    { name: 'Brand Design', path: '/services' },
    { name: 'E-commerce', path: '/services' },
  ];

  return (
    <footer className="relative bg-gradient-to-br from-[#000324] via-[#010536] to-[#020a5c] text-white overflow-hidden">
      {/* Top border gradient */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#fdaa01] via-[#ffc042] to-[#fdaa01]" />
      
      {/* Background decorative elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(253,170,1,0.05)_0%,transparent_50%),radial-gradient(circle_at_80%_80%,rgba(99,102,241,0.05)_0%,transparent_50%)]" />
      <div className="absolute top-10 right-10 w-64 h-64 bg-[#fdaa01]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-10 left-10 w-72 h-72 bg-blue-500/5 rounded-full blur-3xl" />
      
      {/* Main Footer Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <h3 className="text-2xl font-extrabold">
                <span className="text-white">Shyee</span>{' '}
                <span className="bg-gradient-to-r from-[#fdaa01] to-[#ffc042] bg-clip-text text-transparent">
                  Codes
                </span>
              </h3>
            </Link>
            <p className="text-white/70 leading-relaxed mb-6">
              Crafting digital experiences that drive results and inspire innovation.
            </p>
            
            <div className="space-y-3">
              <a 
                href="mailto:shyeecodes@gmail.com" 
                className="group flex items-center gap-3 text-white/70 hover:text-[#fdaa01] transition-colors duration-300"
              >
                <span className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center group-hover:bg-[#fdaa01]/20 group-hover:scale-110 transition-all duration-300">
                  <FaEnvelope className="text-[#fdaa01]" />
                </span>
                <span className="text-sm">shyeecodes@gmail.com</span>
              </a>
              
              <a 
                href="tel:+254762272152" 
                className="group flex items-center gap-3 text-white/70 hover:text-[#fdaa01] transition-colors duration-300"
              >
                <span className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center group-hover:bg-[#fdaa01]/20 group-hover:scale-110 transition-all duration-300">
                  <FaPhoneAlt className="text-[#fdaa01]" />
                </span>
                <span className="text-sm">+254 762 272 152</span>
              </a>
              
              <div className="group flex items-center gap-3 text-white/70">
                <span className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center group-hover:bg-[#fdaa01]/20 group-hover:scale-110 transition-all duration-300">
                  <FaMapMarkerAlt className="text-[#fdaa01]" />
                </span>
                <span className="text-sm">Nairobi, Kenya</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6 flex items-center gap-2">
              <span className="w-8 h-1 bg-[#fdaa01] rounded-full" />
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path}
                    className="group flex items-center gap-2 text-white/70 hover:text-[#fdaa01] transition-all duration-300 hover:translate-x-1"
                  >
                    <FaChevronRight className="text-xs text-[#fdaa01] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    <span>{link.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6 flex items-center gap-2">
              <span className="w-8 h-1 bg-[#fdaa01] rounded-full" />
              Our Services
            </h4>
            <ul className="space-y-3">
              {servicesLinks.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path}
                    className="group flex items-center gap-2 text-white/70 hover:text-[#fdaa01] transition-all duration-300 hover:translate-x-1"
                  >
                    <FaChevronRight className="text-xs text-[#fdaa01] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    <span>{link.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect Section */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6 flex items-center gap-2">
              <span className="w-8 h-1 bg-[#fdaa01] rounded-full" />
              Connect With Us
            </h4>
            
            <div className="flex flex-wrap gap-3 mb-8">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center hover:scale-110 transition-all duration-300"
                  aria-label={social.label}
                  style={{ 
                    '--social-color': social.color,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = social.color;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '';
                  }}
                >
                  <span className="text-lg group-hover:scale-110 transition-transform duration-300">
                    {social.icon}
                  </span>
                  <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 bg-white text-gray-900 text-xs font-semibold px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap">
                    {social.label}
                  </span>
                </a>
              ))}
            </div>
            
            <a
              href="https://calendar.app.google/Ti8ismLSofY2gGci8"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 px-6 py-3 rounded-xl bg-gradient-to-r from-[#fdaa01] to-[#ffc042] text-[#010536] font-semibold shadow-lg shadow-[#fdaa01]/20 hover:shadow-xl hover:shadow-[#fdaa01]/30 hover:scale-105 transition-all duration-300"
            >
              <FaCalendarAlt className="group-hover:rotate-12 transition-transform duration-300" />
              Book a Consultation
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="relative z-10 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/60 text-sm">
              © {currentYear} Shyee Codes. All rights reserved.
            </p>
            
            <p className="flex items-center gap-2 text-white/60 text-sm">
              Made with{' '}
              <FaHeart className="text-red-500 animate-pulse" />{' '}
              in Kenya
            </p>
            
            <div className="flex items-center gap-4 text-sm">
              <Link 
                to="/privacy" 
                className="text-white/60 hover:text-[#fdaa01] transition-colors duration-300"
              >
                Privacy Policy
              </Link>
              <span className="text-white/30">•</span>
              <Link 
                to="/terms" 
                className="text-white/60 hover:text-[#fdaa01] transition-colors duration-300"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;